var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mustShowSubscriptionBtn)?_c('v-btn',{attrs:{"color":"orange","elevation":"1","to":"/app/plans","small":""},domProps:{"innerHTML":_vm._s(_vm.subscriptionBtnText)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }